/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
// from NGL
var ProteinOneLetterCodes = {
  'HIS': 'H',
  'ARG': 'R',
  'LYS': 'K',
  'ILE': 'I',
  'PHE': 'F',
  'LEU': 'L',
  'TRP': 'W',
  'ALA': 'A',
  'MET': 'M',
  'PRO': 'P',
  'CYS': 'C',
  'ASN': 'N',
  'VAL': 'V',
  'GLY': 'G',
  'SER': 'S',
  'GLN': 'Q',
  'TYR': 'Y',
  'ASP': 'D',
  'GLU': 'E',
  'THR': 'T',
  'SEC': 'U',
  'PYL': 'O',
  // charmm ff
  'HSD': 'H',
  'HSE': 'H',
  'HSP': 'H',
  'LSN': 'K',
  'ASPP': 'D',
  'GLUP': 'E',
  // amber ff
  'HID': 'H',
  'HIE': 'H',
  'HIP': 'H',
  'LYN': 'K',
  'ASH': 'D',
  'GLH': 'E'
};
var DnaOneLetterCodes = {
  'DA': 'A',
  'DC': 'C',
  'DG': 'G',
  'DT': 'T',
  'DU': 'U'
};
var RnaOneLetterCodes = {
  'A': 'A',
  'C': 'C',
  'G': 'G',
  'T': 'T',
  'U': 'U'
};
export function getProteinOneLetterCode(residueName) {
  var code = ProteinOneLetterCodes[residueName];
  return code || 'X';
}
export function getRnaOneLetterCode(residueName) {
  var code = RnaOneLetterCodes[residueName];
  return code || 'X';
}
export function getDnaOneLetterCode(residueName) {
  var code = DnaOneLetterCodes[residueName];
  return code || 'X';
}